import Clickable from '@uikit/components/Clickable/Clickable';
import { ClickableAction } from '@uikit/components/Clickable/consts';

type SignetLinkProps = {
  anchorId: string;
  children: React.ReactNode;
  overviewPagePath: string;
  className?: string;
};

const SignetLink = ({
  anchorId,
  children,
  className,
  overviewPagePath,
}: SignetLinkProps) => {
  const link = [overviewPagePath, anchorId].join('#');

  return (
    <Clickable
      actionType={ClickableAction.Linkintern}
      linkintern={link}
      className={className}
    >
      {children}
    </Clickable>
  );
};

export default SignetLink;
